import { createFileRoute } from "@tanstack/react-router";
import { useSuspenseQuery } from "@tanstack/react-query";
import { orpc } from "@/lib/orpc";
import { PcpVisitsCard } from "./-components/care-network/pcp-visits-card";
import { ProvidersCard } from "./-components/providers-card";

export const Route = createFileRoute("/_authenticated/_care/residents/$residentId/primary-care")({
  component: PrimaryCareTab,
});

function PrimaryCareTab() {
  const { residentId } = Route.useParams();
  const { data: resident } = useSuspenseQuery(
    orpc.care.residents.get.queryOptions({ input: { residentId } }),
  );
  return (
    <div className="space-y-6">
      <ProvidersCard
        owner={{ kind: "resident", id: residentId }}
        facilityId={resident.facilityId}
      />
      <PcpVisitsCard residentId={residentId} facilityId={resident.facilityId} />
    </div>
  );
}
